"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var toString = {}.toString;
var getType = function (value) {
    return toString.call(value).replace(/^\[object /, '').replace(/]$/, '');
};
exports.default = getType;
//# sourceMappingURL=get-type.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/get-type.js
// module id = 657
// module chunks = 37